var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 181 59",
    enableBackground: "new 0 0 181 59",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.7,9h3.8c1.1,0,1.9,0.3,2.5,0.8c0.6,0.5,0.9,1.3,0.9,2.2c0,1-0.3,1.7-0.9,2.2c-0.6,0.5-1.4,0.8-2.5,0.8h-2.3v3.7h-1.4 V9z M49.3,13.9c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.6-1.4s-0.2-1.1-0.6-1.4c-0.4-0.3-0.9-0.4-1.6-0.4h-2.2v3.7H49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9,18.6c-0.6-0.3-1-0.7-1.3-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.3,0.5-1.9c0.3-0.5,0.8-1,1.3-1.3 c0.6-0.3,1.2-0.4,2-0.4c0.8,0,1.4,0.1,2,0.4c0.6,0.3,1,0.7,1.4,1.3c0.3,0.5,0.5,1.2,0.5,1.9c0,0.7-0.2,1.4-0.5,1.9 c-0.3,0.5-0.8,0.9-1.4,1.2c-0.6,0.3-1.2,0.4-2,0.4C56.1,19,55.5,18.9,54.9,18.6z M58.6,17.2c0.4-0.4,0.6-1,0.6-1.8 c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-1-0.7-1.7-0.7s-1.3,0.2-1.7,0.7c-0.4,0.4-0.6,1-0.6,1.8c0,0.7,0.2,1.3,0.6,1.8 c0.4,0.4,1,0.7,1.7,0.7S58.2,17.7,58.6,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3,8.5h1.4v10.3h-1.4V8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7,10.5c-0.2-0.2-0.2-0.4-0.2-0.6s0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2 c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2C66.1,10.8,65.9,10.7,65.7,10.5z M65.6,12.1h1.4v6.7h-1.4 V12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,18.4c-0.4-0.4-0.6-0.9-0.6-1.7v-3.6h-1v-1.1h1v-2h1.4v2h1.7v1.1h-1.7v3.5c0,0.4,0.1,0.8,0.3,1 c0.2,0.2,0.5,0.3,0.9,0.3c0.3,0,0.5-0.1,0.8-0.2v1.1C72.6,19,72.1,19,71.6,19C70.9,19,70.4,18.8,70,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,10.5c-0.2-0.2-0.2-0.4-0.2-0.6s0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2 c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2C74.8,10.8,74.6,10.7,74.5,10.5z M74.4,12.1h1.4v6.7h-1.4 V12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3,18.6c-0.6-0.3-1-0.7-1.4-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.4,0.5-1.9c0.3-0.5,0.8-0.9,1.4-1.2 c0.6-0.3,1.3-0.4,2-0.4c1,0,1.8,0.2,2.5,0.6v1.2c-0.6-0.4-1.4-0.6-2.3-0.6c-0.8,0-1.4,0.2-1.9,0.6c-0.5,0.4-0.7,1-0.7,1.8 c0,0.8,0.2,1.4,0.7,1.8s1.1,0.6,1.8,0.6c0.9,0,1.8-0.2,2.4-0.7v1.1c-0.3,0.2-0.7,0.4-1.1,0.5C82.3,19,81.8,19,81.3,19 C80.5,19,79.9,18.9,79.3,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,18.4c-0.5-0.4-0.7-1-0.7-1.7c0-0.7,0.2-1.3,0.7-1.7c0.5-0.4,1.1-0.6,2-0.6c0.9,0,1.7,0.2,2.4,0.6v-0.4 c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.3-0.8-0.4-1.5-0.4c-0.4,0-0.8,0-1.2,0.1c-0.4,0.1-0.7,0.2-1,0.3v-1.1c0.3-0.1,0.6-0.2,1.1-0.3 c0.4-0.1,0.9-0.1,1.3-0.1c1.1,0,1.9,0.2,2.5,0.7c0.5,0.5,0.8,1.2,0.8,2v4.2h-1.3v-0.8c-0.3,0.3-0.6,0.6-1,0.7 c-0.4,0.2-0.9,0.2-1.4,0.2C86.9,19,86.3,18.8,85.8,18.4z M89.3,17.7c0.4-0.2,0.6-0.4,0.8-0.7V16c-0.6-0.4-1.3-0.6-2-0.6 c-0.5,0-0.9,0.1-1.2,0.3c-0.3,0.2-0.4,0.5-0.4,1c0,0.8,0.5,1.2,1.6,1.2C88.5,17.9,88.9,17.9,89.3,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3,8.5h1.4v10.3h-1.4V8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4,9h1.5l3.1,7.8l3.1-7.8h1.5l-3.9,9.8h-1.4L101.4,9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5,10.5c-0.2-0.2-0.2-0.4-0.2-0.6s0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2 c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6s-0.4,0.2-0.6,0.2C111.8,10.8,111.6,10.7,111.5,10.5z M111.4,12.1h1.4v6.7h-1.4V12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,18.6c-0.6-0.3-1-0.7-1.3-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.3,0.5-1.9c0.3-0.5,0.8-1,1.3-1.3 c0.6-0.3,1.2-0.4,2-0.4c0.8,0,1.4,0.1,2,0.4c0.6,0.3,1,0.7,1.4,1.3c0.3,0.5,0.5,1.2,0.5,1.9c0,0.7-0.2,1.4-0.5,1.9 c-0.3,0.5-0.8,0.9-1.4,1.2c-0.6,0.3-1.2,0.4-2,0.4C117.5,19,116.9,18.9,116.3,18.6z M120,17.2c0.4-0.4,0.6-1,0.6-1.8 c0-0.8-0.2-1.4-0.6-1.8c-0.4-0.4-1-0.7-1.7-0.7c-0.7,0-1.3,0.2-1.7,0.7c-0.4,0.4-0.6,1-0.6,1.8c0,0.7,0.2,1.3,0.6,1.8 c0.4,0.4,1,0.7,1.7,0.7C119,17.9,119.6,17.7,120,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.7,8.5h1.4v10.3h-1.4V8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,18.1c-0.7-0.6-1.1-1.5-1.1-2.6c0-1.1,0.3-2,0.9-2.6c0.6-0.6,1.5-1,2.7-1c0.8,0,1.4,0.1,2,0.4 c0.5,0.3,0.9,0.7,1.2,1.2s0.4,1.1,0.4,1.8V16H128c0,0.6,0.3,1.1,0.8,1.4c0.5,0.3,1.2,0.5,2,0.5c0.4,0,0.9,0,1.3-0.1 c0.4-0.1,0.8-0.2,1.2-0.3v1.1c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.4,0.1C129.3,19,128.4,18.7,127.7,18.1z M132.5,15 c0-0.6-0.2-1.1-0.6-1.5s-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5S128,14.4,128,15H132.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.4,12.1h1.4v1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.7,1.1,0.7,1.9v4.3 h-1.4v-4.2c0-1.1-0.5-1.6-1.6-1.6c-0.4,0-0.9,0.1-1.3,0.3s-0.7,0.5-1,1v4.5h-1.4V12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,18.6c-0.6-0.3-1-0.7-1.4-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.4,0.5-1.9s0.8-0.9,1.4-1.2 c0.6-0.3,1.3-0.4,2-0.4c1,0,1.8,0.2,2.5,0.6v1.2c-0.6-0.4-1.4-0.6-2.3-0.6c-0.8,0-1.4,0.2-1.9,0.6c-0.5,0.4-0.7,1-0.7,1.8 c0,0.8,0.2,1.4,0.7,1.8s1.1,0.6,1.8,0.6c0.9,0,1.8-0.2,2.4-0.7v1.1c-0.3,0.2-0.7,0.4-1.1,0.5s-0.9,0.2-1.5,0.2 C146.6,19,145.9,18.9,145.4,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2,18.1c-0.7-0.6-1.1-1.5-1.1-2.6c0-1.1,0.3-2,0.9-2.6s1.5-1,2.7-1c0.8,0,1.4,0.1,2,0.4c0.5,0.3,0.9,0.7,1.2,1.2 c0.3,0.5,0.4,1.1,0.4,1.8V16h-5.9c0,0.6,0.3,1.1,0.8,1.4s1.2,0.5,2,0.5c0.4,0,0.9,0,1.3-0.1c0.4-0.1,0.8-0.2,1.2-0.3v1.1 c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.4,0.1C153.9,19,152.9,18.7,152.2,18.1z M157.1,15c0-0.6-0.2-1.1-0.6-1.5 c-0.4-0.4-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5c-0.4,0.4-0.6,0.8-0.6,1.5H157.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7,25.8h1.4v9.8h-1.4V25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9,28.9h1.4v1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.7,1.1,0.7,1.9v4.3h-1.4 v-4.2c0-1.1-0.5-1.6-1.6-1.6c-0.4,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-1,1v4.5h-1.4V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3,35.6c-0.5-0.1-0.9-0.3-1.2-0.5V34c0.4,0.2,0.8,0.4,1.3,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.5,0,0.9-0.1,1.1-0.2 c0.2-0.1,0.4-0.3,0.4-0.6c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3-0.1-0.6-0.2-1.2-0.4c-0.6-0.2-1-0.3-1.3-0.5 c-0.3-0.2-0.6-0.4-0.7-0.6c-0.2-0.3-0.2-0.6-0.2-1c0-0.6,0.3-1.1,0.8-1.5c0.5-0.3,1.2-0.5,2.1-0.5c0.4,0,0.9,0,1.3,0.1 s0.8,0.2,1,0.4v1.2c-0.3-0.2-0.6-0.3-1-0.4c-0.4-0.1-0.8-0.1-1.2-0.1c-0.5,0-0.9,0.1-1.1,0.2c-0.3,0.1-0.4,0.3-0.4,0.6 c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.6,0.2,1.2,0.3c0.8,0.2,1.4,0.5,1.8,0.8c0.3,0.3,0.5,0.8,0.5,1.3 c0,0.6-0.2,1-0.7,1.4c-0.5,0.3-1.2,0.5-2.1,0.5C59.4,35.8,58.9,35.8,58.3,35.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8,35.1c-0.5-0.5-0.7-1.1-0.7-1.9v-4.3h1.4v4.2c0,1.1,0.5,1.6,1.6,1.6c0.9,0,1.7-0.4,2.2-1.3v-4.5h1.4v6.7h-1.4v-1 c-0.3,0.4-0.7,0.7-1.1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3C66,35.8,65.3,35.6,64.8,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6,28.9H74v1.2c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,1.1-0.3,1.8-0.3V30c-0.7,0-1.3,0.1-1.8,0.3c-0.5,0.2-0.9,0.6-1.1,1.1 v4.2h-1.4V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,35.2c-0.5-0.4-0.7-1-0.7-1.7c0-0.7,0.2-1.3,0.7-1.7s1.1-0.6,2-0.6c0.9,0,1.7,0.2,2.4,0.6v-0.4c0-0.5-0.2-0.9-0.5-1.2 s-0.8-0.4-1.5-0.4c-0.4,0-0.8,0-1.2,0.1s-0.7,0.2-1,0.3v-1.1c0.3-0.1,0.6-0.2,1.1-0.3c0.4-0.1,0.9-0.1,1.3-0.1 c1.1,0,1.9,0.2,2.5,0.7c0.5,0.5,0.8,1.2,0.8,2v4.2h-1.3v-0.8c-0.3,0.3-0.6,0.6-1,0.7s-0.9,0.2-1.4,0.2 C79.1,35.8,78.5,35.6,78,35.2z M81.5,34.5c0.4-0.2,0.6-0.4,0.8-0.7v-0.9c-0.6-0.4-1.3-0.6-2-0.6c-0.5,0-0.9,0.1-1.2,0.3 s-0.4,0.5-0.4,1c0,0.8,0.5,1.2,1.6,1.2C80.7,34.7,81.2,34.7,81.5,34.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5,28.9h1.4v1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.7,1.1,0.7,1.9v4.3h-1.4 v-4.2c0-1.1-0.5-1.6-1.6-1.6c-0.4,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-1,1v4.5h-1.4V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5,35.4c-0.6-0.3-1-0.7-1.4-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.4,0.5-1.9c0.3-0.5,0.8-1,1.4-1.2 c0.6-0.3,1.3-0.4,2-0.4c1,0,1.8,0.2,2.5,0.6v1.2c-0.6-0.4-1.4-0.6-2.3-0.6c-0.8,0-1.4,0.2-1.9,0.6c-0.5,0.4-0.7,1-0.7,1.8 c0,0.8,0.2,1.4,0.7,1.8c0.5,0.4,1.1,0.6,1.8,0.6c0.9,0,1.8-0.2,2.4-0.7v1.1c-0.3,0.2-0.7,0.4-1.1,0.5s-0.9,0.2-1.5,0.2 C96.7,35.8,96,35.7,95.5,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.3,34.9c-0.7-0.6-1.1-1.5-1.1-2.6c0-1.1,0.3-2,0.9-2.6s1.5-1,2.7-1c0.8,0,1.4,0.1,2,0.4c0.5,0.3,0.9,0.7,1.2,1.2 c0.3,0.5,0.4,1.1,0.4,1.8v0.7h-5.9c0,0.6,0.3,1.1,0.8,1.4s1.2,0.5,2,0.5c0.4,0,0.9,0,1.3-0.1s0.8-0.2,1.2-0.3v1.1 c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.4,0.1C104,35.8,103,35.5,102.3,34.9z M107.2,31.8c0-0.6-0.2-1.1-0.6-1.5 c-0.4-0.4-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5c-0.4,0.4-0.6,0.8-0.6,1.5H107.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.9,18.4l0,0.5 c-0.1,0.9-0.4,1.8-0.9,2.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M22.4,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M22.8,11.6 l2.9-2.9C26.4,8,27.4,8,28,8.7l0,0c0.6,0.6,0.6,1.6,0,2.2l-2.3,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M25.8,13.1 l2.8-2.8c0.6-0.6,1.6-0.6,2.2,0l0,0c0.6,0.6,0.6,1.6,0,2.2L26,17.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M26.9,18.7 L26.9,18.7c-0.6-0.6-0.6-1.6,0-2.2l3.3-3.3c0.6-0.6,1.6-0.6,2.2,0l0,0c0.6,0.6,0.6,1.6,0,2.2l-3.3,3.3 C28.5,19.3,27.5,19.3,26.9,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M28.6,21.5 L28.6,21.5c-0.6-0.6-0.6-1.6,0-2.2l3.5-3.5c0.6-0.6,1.6-0.6,2.2,0h0c0.6,0.6,0.6,1.6,0,2.2l-3.5,3.5 C30.2,22.1,29.2,22.1,28.6,21.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M18.6,14 c0-1.3,1.1-2.4,2.4-2.4l2.3-0.1c1.3,0,2.4,1.1,2.4,2.4v4.5l-1.1,0c-1.2,0-2.2-1-2.2-2.2v-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M20.3,28.4 l3.4-3.4l0,0c1.3,0.6,2.9,0.3,3.9-0.7l2.1-2.1"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M23.9,5.4 c3.3,1,4.9,0.3,6.7-2.8c1.8,3,3.4,3.7,6.7,2.8c-1,3.3-0.3,4.9,2.8,6.7c-3,1.8-3.7,3.4-2.8,6.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M19.5,16.5 c-3-0.4-6-2.7-7.2-3.7c-0.3-0.3-0.9-0.3-1.2,0c-1.2,1.1-4.2,3.3-7.2,3.7C3.4,16.6,3,17,3,17.5c0.4,9.3,6.5,13.3,8.2,14.3 c0.3,0.2,0.6,0.2,0.9,0c1.7-1,7.8-5,8.2-14.3C20.3,17,20,16.6,19.5,16.5z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 8.2,
    y1: 22.2,
    x2: 15.1,
    y2: 22.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 11.7,
    y1: 18.8,
    x2: 11.7,
    y2: 25.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 25.7,
    y1: 27.1,
    x2: 36.8,
    y2: 27.1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 31.2,
    y1: 27.1,
    x2: 31.2,
    y2: 39
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 27.6,
    y1: 39,
    x2: 34.9,
    y2: 39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M36.8,33.9 L36.8,33.9c-1.1,0-2.1-0.6-2.6-1.6l-0.5-1h6.2l-0.5,1C38.9,33.3,37.9,33.9,36.8,33.9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "34.6,31  36.8,27.1 39,31  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M25.7,33.9 L25.7,33.9c-1.1,0-2.1-0.6-2.6-1.6l-0.5-1h6.2l-0.5,1C27.8,33.3,26.8,33.9,25.7,33.9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "23.5,31  25.7,27.1 27.9,31  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon-7.738e130649236636b365509351ce9b3f.svg";
export { ForwardRef as ReactComponent };